import { useTranslation } from "react-i18next";

import { cn } from "@/shared/lib/cn";

/**
 * Statut d'un compte.
 *
 * La couleur **double** le texte, elle ne le remplace pas : un badge distingué
 * par la seule teinte est invisible pour un daltonien, et docs/24 impose le
 * contraste comme l'information redondante.
 */
const TONES: Record<string, string> = {
  active: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300",
  pending: "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300",
  suspended: "bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300",
  deactivated: "bg-slate-200 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
};

export function StatusBadge({ status }: { status: string }) {
  const { t } = useTranslation("admin");
  return (
    <span
      className={cn(
        "inline-flex rounded-full px-2 py-0.5 text-xs font-medium",
        TONES[status] ?? TONES["deactivated"],
      )}
    >
      {t(`status.${status}`, { defaultValue: status })}
    </span>
  );
}
